import React, { FC } from 'react';

import { IFAQ } from '@/src/assets/interfaces/faqInterface';
import { advInfoFull } from '@/src/assets/objects/advInfo';
import { baseUrl } from '@/src/assets/utils/baseUrl';

import { ITheme } from '../../../assets/interfaces/themeInterface/index';
import { Title } from '../../UI/title/Title';
import Wrapper from '../../UI/wrapper/Wrapper';
import AdvantageList from '../../advantageList/AdvantageList';
import Layout from '../../layout/Layout';
import BundleSection from '../../sections/bundleSection/BundleSection';
import FAQSection from '../../sections/faqSection/FAQSection';
import ThemesList from '../../themesList/ThemesList';

import styles from './Bundle.module.scss';

type TBundleData = {
    themesData: Partial<ITheme>[];
    faqData: IFAQ[];
};

const Bundle: FC<TBundleData> = ({ themesData, faqData }) => {
    const jsonLd = {
        '@context': 'https://schema.org/',
        '@type': 'WebPage',
        name: 'High Five Themes Bundle',
        description:
            'Harness the ethereal power of this platform to captivate your audience and unleash the full potential of your content.',
        url: `${baseUrl('bundle')}`,
    };

    const headingDemo = 'All Ghost Themes in One Bundle';
    const headingAdv = 'Essential Theme Features for Enhanced Online Performance';

    const excerptDemo = `Get instant access to our full library of Ghost Themes with a single, convenient bundle
  purchase.`;
    const excerptAdv = `More features, more advantages, and more opportunities to grow your online presence.`;

    return (
        <Layout
            meta={{
                metaTitle: 'Get Ghost Themes Bundle | High Five Themes',
                metaDescription:
                    'Get a Ghost themes bundle, including 12 premium responsive themes with awesome designs and features. Pay a one-time purchase fee and get lifetime access.',
            }}
            jsonLD={jsonLd}>
            <BundleSection className={styles.bundle__top} isMain={true} />
            <section className={styles.themes}>
                <Wrapper>
                    <Title text={headingDemo} size="lg" className={styles['section-heading']} />

                    <p className={`excerpt body-lg excerpt-wrap ${styles.excerpt}`}>
                        {excerptDemo}
                    </p>
                    {themesData && (
                        <ThemesList themesData={themesData} additionalClass="bundle-list" />
                    )}
                </Wrapper>
            </section>
            <section className={styles.advantage__section}>
                <Wrapper>
                    <Title text={headingAdv} size="lg" className={styles['section-heading']} />
                    <p className={`excerpt body-lg excerpt-wrap ${styles.excerpt}`}>{excerptAdv}</p>
                    <AdvantageList advList={advInfoFull} />
                </Wrapper>
            </section>
            {faqData && <FAQSection faqList={faqData} />}
            <BundleSection className={styles.bundle__bottom} />
        </Layout>
    );
};

export default Bundle;
